import { render, staticRenderFns } from "./XInput.vue?vue&type=template&id=cb6f594e&scoped=true&"
import script from "./XInput.vue?vue&type=script&lang=ts&"
export * from "./XInput.vue?vue&type=script&lang=ts&"
import style0 from "./XInput.vue?vue&type=style&index=0&id=cb6f594e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6f594e",
  null
  
)

export default component.exports